
import { createApiClient } from 'Network/ApiClient';

export const DrugNotAllowedwithIcdAxiosInstance = createApiClient('DrugsNotIcd/');


